import { GlobalsQueryVariables } from '@/__generated__/graphql';
import { GLOBALS_QUERY } from '@/gql/queries/globals.gql';
import { useQuery } from '@apollo/client';
import { firstNonNullable } from '@/lib/helpers';
import { AppGlobal, GlobalTypename, parseGlobals } from '../parsers/globals';

export const useGlobal = <TName extends GlobalTypename>(
  variables: GlobalsQueryVariables = {},
  typeNames: TName
) => {
  const { data, loading, error } = useQuery(GLOBALS_QUERY, {
    variables,
  });

  if (error) console.warn(error.message);

  const result = parseGlobals(data?.globalSets);

  const global = firstNonNullable(result) as AppGlobal<typeof typeNames>;

  return {
    ...global,
    loading,
    error,
  };
};
